export const TEST_ID = 'batteryStatusPill';
